var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 4,
    viewBox: "0 0 8 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666992 0.333008L4.00033 3.66634L7.33366 0.333008H0.666992Z",
    fill: "#205274"
  })));
}
export default __webpack_public_path__ + "static/media/new-arrow-down.4b503b7b.svg";
export { SvgNewArrowDown as ReactComponent };